import React from 'react';

import AdminProgressTrackerListContainer from '@src/components/user/list/AdminProgressTrackerListContainer';
import { ProgressTrackerTypeEnum } from '@src/model/progresstracker/ProgressTracker';

const AdminUserProgressTrackerPage = () => <AdminProgressTrackerListContainer type={ProgressTrackerTypeEnum.USER_PARSER} />;

export default AdminUserProgressTrackerPage;
